import { SimpleMembershipCard } from "basket_and_checkout/shared/components/Membership/SimpleMembershipCard/SimpleMembershipCard";
import { getMembershipVisualUrl } from "components/Basket/components/Cards/Card.utils";
import { useBasketBuckets } from "hooks";
import { userVar } from "lib/user";
import React from "react";
import type { ItemType } from "@shared/graphql.types";
import { MembershipCard } from "../../Basket/components/Cards/Membership/MembershipCard";
import { useOnRemoveBasketItem } from "../BasketList.utils";
import type { ProductListVariants } from "../ProductList/ProductList";
import { simpleMembershipCardContainer } from "./MembershipList.css";
import { Container } from "./MembershipList.styles";
import { useFragment } from "@apollo/client";
import { MEMBERSHIP_TOGGLE_CARD_FRAGMENT } from "lib/apollo/fragments";

interface Props {
  variant?: ProductListVariants;
}

export const MembershipList: React.FC<Props> = ({ variant = "basket" }) => {
  const { memberships } = useBasketBuckets();
  const { pricing } = userVar();
  const { onRemoveBasketItem } = useOnRemoveBasketItem(variant);
  const { data } = useFragment({
    fragment: MEMBERSHIP_TOGGLE_CARD_FRAGMENT,
    fragmentName: "MembershipToggleCardFragment",
    from: {
      __typename: "BasketMembershipToggleCardType",
      id: "basket-membership-toggle"
    }
  });
  const { membershipId: currentToggleMembershipId } = data;

  if (memberships.length === 0) return null;

  const isCheckout = variant === "checkout";
  const isAtbConfirmation = variant === "atbConfirmation";

  if (isAtbConfirmation)
    return (
      <div
        className={simpleMembershipCardContainer}
        data-testid="membership-items"
      >
        {memberships.map((item: ItemType) => {
          const imageUrl = getMembershipVisualUrl(item?.membership?.visual);
          return (
            <SimpleMembershipCard
              imageUrl={imageUrl}
              key={item.id}
              item={item}
              variant={variant}
              pricing={pricing}
            />
          );
        })}
      </div>
    );

  return (
    <Container data-testid="membership-items">
      {memberships.map((item: ItemType) => {
        // This is here specifically to remove whatever membership card is the current membership option displayed in the membership toggle card, e.g. if plus is the membership toggle card, then we don't display the plus card here
        if (
          variant === "basket" &&
          item.membership?.id === currentToggleMembershipId
        ) {
          return;
        }

        return (
          <MembershipCard
            key={item.id}
            item={item}
            variant={variant}
            hideRemoveButton={isCheckout}
            pricing={pricing}
            onRemoveBasketItem={onRemoveBasketItem}
          />
        );
      })}
    </Container>
  );
};
